import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { keyframes, styled } from '@stitches/react';

import { ChevronDownIcon } from '@radix-ui/react-icons';
import { ReactNode, forwardRef } from 'react';
import { theme } from '../../../tailwind.theme';
import { COLORS } from '@lib/constants';

const slideDown = keyframes({
  from: { height: 0 },
  to: { height: 'var(--radix-accordion-content-height)' }
});

const slideUp = keyframes({
  from: { height: 'var(--radix-accordion-content-height)' },
  to: { height: 0 }
});

const StyledAccordion = styled(AccordionPrimitive.Root, {
  borderRadius: 6
});

const StyledItem = styled(AccordionPrimitive.Item, {
  overflow: 'hidden',
  marginTop: 1,

  '&:focus-within': {
    position: 'relative',
    zIndex: 1
  }
});

const StyledHeader = styled(AccordionPrimitive.Header, {
  all: 'unset',
  display: 'flex',
  margin: 0,
  paddingBottom: '4px'
});

const StyledTrigger = styled(AccordionPrimitive.Trigger, {
  all: 'unset',
  fontFamily: 'Poppins',
  fontWeight: 400,
  paddingLeft: 2,
  paddingRight: 2,
  minHeight: 45,
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  lineHeight: 1,
  backdropFilter: 'initial',
  color: COLORS.primary1,
  cursor: 'pointer'
});

const StyledContent = styled(AccordionPrimitive.Content, {
  overflow: 'hidden',
  '&[data-state="open"]': {
    animation: `${slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1)`
  },
  '&[data-state="closed"]': {
    animation: `${slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1)`
  }
});

const StyledContentText = styled('div', {
  padding: '8px 0px 24px 0'
});

const StyledChevron = styled(ChevronDownIcon, {
  color: theme.colors.neutral['600'],
  transition: 'transform 300ms cubic-bezier(0.87, 0, 0.13, 1)',
  width: '16px',
  height: '16px',
  '[data-state=closed] &': {
    transform: 'rotate(-90deg)',
    color: theme.colors.neutral['600']
  },
  '[data-state=open] &': {
    color: theme.colors.neutral['600']
  }
});

interface IAccordionProps {
  children: ReactNode;
  className?: string;
}

interface IAccordionProps {
  children: ReactNode;
  className?: string;
}

export const Accordion = StyledAccordion;
export const AccordionItem = StyledItem;
export const AccordionChevron = StyledChevron;
export const AccordionTrigger = forwardRef(
  ({ children, className, ...props }: IAccordionProps, forwardedRef) => (
    <StyledHeader>
      {/*  @ts-ignore */}
      <StyledTrigger {...props} ref={forwardedRef} className={className}>
        {children}
      </StyledTrigger>
    </StyledHeader>
  )
);
export const AccordionContent = forwardRef(
  ({ children, ...props }: IAccordionProps, forwardedRef) => (
    <>
      {/*  @ts-ignore */}
      <StyledContent {...props} ref={forwardedRef}>
        <StyledContentText>{children}</StyledContentText>
      </StyledContent>
    </>
  )
);
